import type { AssetStatus } from "@/lib/api";
import { availabilityColorClass, availabilityLabel } from "@/lib/format";

interface StatusBadgeProps {
  status: AssetStatus;
}

/** O porquê do «Expirado», que o selo sozinho não diz (F-GC.4). */
const EXPIRED_HINT = "Os arquivos deste item saíram do viewer para liberar espaço. Reenvie pela plataforma para abri-lo.";

export function StatusBadge({ status }: StatusBadgeProps) {
  return (
    <span
      className={`rounded px-1.5 py-0.5 text-[10px] uppercase tracking-wide ${availabilityColorClass(
        status,
      )}`}
      title={status === "expired" ? EXPIRED_HINT : undefined}
    >
      {availabilityLabel(status)}
    </span>
  );
}
